import {ILangdict, Langdict} from './langdict';

export class ICourseGroup {
  id: string;
  description: ILangdict;
}

export class CourseGroup extends ICourseGroup {
  constructor(obj: ICourseGroup) {
    super();
    this.id = obj.id;
    this.description = new Langdict(obj.description);
  }

  getPathFragment() {
    return [this.id];
  }
}

